import React from 'react'

const ApprovalIcon = ({ color = 'white', width = 20, height = 19 }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14 3.98291H18C19.11 3.98291 20 4.8691 20 5.97436V16.9274C20 18.0326 19.11 18.9188 18 18.9188H2C0.89 18.9188 0 18.0326 0 16.9274L0.01 5.97436C0.01 4.8691 0.89 3.98291 2 3.98291H6V1.99145C6 0.886197 6.89 0 8 0H12C13.11 0 14 0.886197 14 1.99145V3.98291ZM8 3.98291H12V1.99145H8V3.98291Z"
        fill={color}
      />
    </svg>
  )
}

export default ApprovalIcon